<!-- 底部 -->
<template>
  <footer class="footer">
    <div class="container w1200">
      <div class="footer-main">
        <div class="left">
          <img src="@/assets/full_logo_white.png" alt="logo" class="logo" />
          <div class="slogan">匠心咨询 成就匠心建筑</div>
        </div>
        <div class="center">
          <div class="about">
            <p>
              联系电话：<span>{{ globalConfig.linkPhone }}</span>
            </p>
            <p>地址：{{ globalConfig.linkAddress }}</p>
          </div>
        </div>
        <div class="right">
          <img
            :src="URL + globalConfig.wechatQrcodeUrl"
            alt="微信二维码"
            class="code"
          />
        </div>
        <div class="navs">
          <div
            class="nav"
            v-for="(item, idx) in navList"
            :key="item.path"
            @click="navTo(item)"
          >
            <span v-if="idx == 0">{{
              item.name
                .split("")
                .join("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;")
            }}</span>
            <span v-else>{{ item.name }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="copy">
      <span>{{ globalConfig.copyRightMsg }}</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow">{{
        globalConfig.icpMsg
      }}</a>
    </div>
  </footer>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import { URL } from "../../util/config";
export default {
  data() {
    return {
      URL,
    };
  },
  props: {
    navList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(Store, ["globalConfig", "isMobile"]),
  },
  created() {},
  mounted() {},
  methods: {
    navTo(item) {
      window.scrollTo({ top: 0 });
      if (item.subs && item.subs.length != 0) {
        this.$router.push(item.subs[0].path);
        return;
      }
      this.$router.push(item.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  color: #fff;
  background-color: #52565a;

  .container {
    text-align: center;
    color: #fff;

    .footer-main {
      padding: 60px 0;
      border-bottom: 1px solid #575757;
      display: flex;
      align-items: center;

      .left {
        margin-right: 40px;

        .logo {
          width: 260px;
        }
        .slogan {
          font-size: 18px;
          margin-top: 30px;
          opacity: 0.7;
          letter-spacing: 5px;
        }
      }
      .center {
        width: 330px;
        flex-shrink: 0;
        text-align: left;
        margin-right: 50px;

        .about {
          font-size: 16px;
          color: #d8d6d6;

          p {
            span {
              font-size: 36px;
              font-weight: bold;
            }
          }

          p + p {
            margin-top: 12px;
            line-height: 1.5;
          }
        }
      }
      .right {
        margin-right: 50px;

        .code {
          width: 100px;
        }
      }
      .navs {
        flex-grow: 1;
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        margin-bottom: 15px;

        .nav {
          width: 86px;
          padding: 0 15px;
          margin: 8px 0;
          box-sizing: border-box;
          // text-align-last: justify;
          cursor: pointer;
          position: relative;

          &:hover {
            color: $theme;
          }
          &::after {
            content: "";
            display: block;
            width: 1px;
            height: 60%;
            background-color: #fff;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
          }
          &:last-child::after,
          &:nth-child(4n)::after {
            display: none;
          }
        }
      }
    }
  }
  .copy {
    padding: 10px 0;
    font-size: 13px;
    color: #b3b3b3;
    border-top: 1px solid #7f8081;
    text-align: center;

    a {
      margin: 0 10px;
    }
    a:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 750px) {
  .footer .container .footer-main {
    flex-direction: column;
    padding: 20px 0;

    .left {
      margin-right: 0;

      .slogan {
        font-size: 16px;
        margin-top: 10px;
      }
    }
    .center {
      margin-right: 0;
      margin-top: 10px;

      .about {
        font-size: 14px;

        p span {
          font-size: 25px;
        }
      }
    }
    .right {
      margin-right: 0;
      margin-top: 10px;
    }
    .navs {
      margin-top: 10px;
      margin-bottom: 0;
      justify-content: center;
    }
  }
}
</style>
